// Global toast container — mount once at app root. Subscribes to the pub-sub in lib/theme.js.
import React from "react";
import { useToasts } from "./lib/theme";
import { zVar } from "./lib/zIndex";

export default function Toaster() {
  const [toasts, dismiss] = useToasts();
  if (!toasts.length) return null;
  return (
    <div
      data-testid="toaster"
      style={{
        position: "fixed",
        bottom: 20,
        insetInlineEnd: 20,
        zIndex: zVar('extra_9999'),
        display: "flex",
        flexDirection: "column",
        gap: 8,
        maxWidth: 360,
      }}
    >
      {toasts.map((t) => (
        <div
          key={t.id}
          data-testid={`toast-${t.id}`}
          style={{
            background: "var(--card)",
            color: "var(--text)",
            border: "1px solid var(--border)",
            borderInlineStart: `4px solid ${t.kind === "danger" ? "var(--danger)" : t.kind === "success" ? "var(--success)" : "var(--info)"}`,
            padding: "10px 14px",
            borderRadius: 6,
            boxShadow: "0 10px 30px rgba(0,0,0,0.18)",
            display: "flex",
            alignItems: "center",
            gap: 10,
            fontSize: 13,
          }}
        >
          <div style={{ flex: 1, lineHeight: 1.6 }}>{t.message}</div>
          {t.undoable && (
            <button
              type="button"
              className="btn btn-soft"
              onClick={() => { if (t.onUndo) t.onUndo(); dismiss(t.id); }}
              data-testid={`undo-${t.id}`}
              style={{ fontSize: 11, padding: "3px 10px", whiteSpace: "nowrap" }}
            >
              ↩ تراجع
            </button>
          )}
          <button
            type="button"
            onClick={() => dismiss(t.id)}
            data-testid={`dismiss-${t.id}`}
            style={{ background: "transparent", border: 0, color: "var(--muted)", cursor: "pointer", fontSize: 16, lineHeight: 1 }}
            aria-label="إغلاق"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
}
